import React, { useState, useEffect } from "react";

interface CohortCountdownProps {
  displayStartDate: Date;
  displayEndDate: Date;
}

const CohortCountdown: React.FC<CohortCountdownProps> = ({
  displayStartDate,
  displayEndDate,
}) => {
  const [timeRemaining, setTimeRemaining] = useState<{
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  } | null>(null);

  const [showTimer, setShowTimer] = useState<boolean>(true);
  const formatNumber = (num: number) => String(num).padStart(2, "0");

  useEffect(() => {
    const updateTimer = () => {
      const now = new Date();

      // If the current date is before displayStartDate or after displayEndDate, hide the timer
      if (now < displayStartDate || now > displayEndDate) {
        setShowTimer(false);
        return;
      }

      // If the current date is within the display range, calculate time remaining
      setShowTimer(true);
      const timeDiff = displayEndDate.getTime() - now.getTime();

      if (timeDiff <= 0) {
        setTimeRemaining(null);
        return;
      }

      const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
      const seconds = Math.floor((timeDiff / 1000) % 60);

      setTimeRemaining({ days, hours, minutes, seconds });
    };

    // Update the timer every second
    const intervalId = setInterval(updateTimer, 1000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, [displayStartDate, displayEndDate]);


  if (!timeRemaining) return null;

    return (
    
        <>
            {showTimer && 
            <div
            className="flex flex-col justify-center items-center"
          >
            <h1
              style={{
                fontSize: "32px",
                fontWeight: "500",
                paddingTop: "17px",
                paddingBottom: "17px",
                color: "#0F4B16",
              }}
            >
              Next Cohort Starts In
            </h1>
            <div className="flex sm:flex-row flex-col lg:flex-row xl:flex-row justify-center items-center flex-nowrap whitespace-nowrap text-nowrap sm:gap-4 gap-20 text-[#222222] mb-4">
              <div className="sm:w-20 sm:h-24 w-40 h-40 flex flex-col justify-center sm:text-3xl text-7xl font-bold border rounded-lg sm:p-1 p-3 bg-[#F2FFD8] border-[#F2FFD8] text-center shadow-md">
                {formatNumber(timeRemaining.days)}
                <span className="text-lg font-medium"> Days</span>
              </div>
              <div className="sm:w-20 sm:h-24 w-40 h-40 flex flex-col justify-center sm:text-3xl text-7xl font-bold border rounded-lg sm:p-1 p-3 bg-[#F2FFD8] border-[#F2FFD8] text-center shadow-md">
                {formatNumber(timeRemaining.hours)}
                <span className="text-lg font-medium"> Hours</span>
              </div>
              <div className="sm:w-24 sm:h-24 w-40 h-40 flex flex-col justify-center sm:text-3xl text-7xl font-bold border rounded-lg sm:p-1 p-3 bg-[#F2FFD8] border-[#F2FFD8] text-center shadow-md">
                {formatNumber(timeRemaining.minutes)}
                <span className="text-lg font-medium"> Minutes</span>
              </div>
              <div className="sm:w-24 sm:h-24 w-40 h-40 flex flex-col justify-center sm:text-3xl text-7xl font-bold border rounded-lg sm:p-1 p-3 bg-[#F2FFD8] border-[#F2FFD8] text-center shadow-md">
                {formatNumber(timeRemaining.seconds)}
                <span className="text-lg font-medium"> Seconds</span>
              </div>
            </div>
          </div>}
        </>
  );
};

export default CohortCountdown;
